import React from "react"

export const columnConfig = ({
  onShowPosts,
  stopRunpodWorker,
  setGpuIndex,
}: {
  onShowPosts: (postIds: string[]) => void
  stopRunpodWorker: (pod_id: string) => void
  setGpuIndex: React.Dispatch<React.SetStateAction<number>>
}) => [
  {
    accessor: "id",
    title: "Worker ID",
    sortable: true,
    render: (record: any) => <span>{record.id}</span>,
  },
  {
    accessor: "is_active",
    title: "Active",
    sortable: true,
    render: (record: any) => (
      <span className={record.is_active ? "text-green-600" : "text-red-600"}>
        {record.is_active ? "Active" : "Inactive"}
      </span>
    ),
  },
  {
    accessor: "is_running",
    title: "Running",
    sortable: true,
    render: (record: any) => (
      <span className={record.is_running ? "text-green-600" : "text-red-600"}>
        {record.is_running ? "Running" : "Stopped"}
      </span>
    ),
  },
  {
    accessor: "stop_or_start",
    title: "Durum Değiştir",
    sortable: true,
    render: (record: any) => (
      <span
        className={"cursor-pointer " + (record.is_running ? "text-red-600" : "text-green-600")}
        onClick={() => stopRunpodWorker(record.pod_id)}
      >
        Stop
      </span>
    ),
  },
  {
    accessor: "gpu_count",
    title: "GPUs",
    sortable: true,
  },
  ...Array.from({ length: 8 }).map((_, idx) => ({
    accessor: `gpu_usage_${idx + 1}`,
    title: `GPU ${idx + 1} Usage`,
    render: (record: any) => {
      const gpus = Object.values(record.gpu_statuses || {}) as { usage?: number }[]
      const usage = gpus[idx]?.usage
      let postIds: unknown = undefined
      if (record.recent_post_ids && typeof record.recent_post_ids === "object") {
        postIds = record.recent_post_ids[idx]
      }
      return usage !== undefined ? (
        <span
          className={
            "text-xs text-gray-700 leading-tight cursor-pointer hover:text-blue-600 underline" +
            (Array.isArray(postIds) && postIds.length ? "" : " opacity-50 cursor-not-allowed")
          }
          onClick={() => {
            setGpuIndex(idx + 1)
            if (Array.isArray(postIds) && postIds.length) {
              onShowPosts(postIds.filter((id: unknown): id is string => typeof id === "string"))
            }
          }}
        >
          {usage}%
        </span>
      ) : null
    },
    width: "60px",
  })),
  {
    accessor: "gpu_avg_usage",
    title: "GPU Avg",
    render: (record: any) => {
      const gpus = Object.values(record.gpu_statuses || {})
      const usages = gpus.map((g: any) => g.usage)
      const avg = usages.length ? (usages.reduce((a, b) => a + b, 0) / usages.length).toFixed(1) : 0
      return <span className="font-medium text-xs text-blue-700 leading-tight">{avg}%</span>
    },
    width: "60px",
  },
  {
    accessor: "processed_count",
    title: "Processed",
    sortable: true,
  },
  {
    accessor: "query",
    title: "Query",
    sortable: false,
    render: (record: any) => {
      const q = record.query || {}
      const parts: string[] = []

      if (q.hashtag_brand && q.hashtag_brand.$exists === true) {
        parts.push("hashtag_brand exists")
      }

      if (Array.isArray(q.$or)) {
        const orConditions = q.$or
          .map((c: any) => {
            const key = Object.keys(c)[0]
            return `${key} = ${c[key]}`
          })
          .join(" OR ")

        parts.push(`(${orConditions})`)
      }

      const output = parts.join(", ")
      return <span className="text-xs text-gray-700">{output || "-"}</span>
    },
  },
  {
    accessor: "total_count",
    title: "Total",
    sortable: true,
  },
  {
    accessor: "avg_time_per_post",
    title: "Avg Time/Post",
    sortable: true,
    render: (r: any) => <span>{r.avg_time_per_post}s</span>,
  },
  {
    accessor: "estimated_remaining_hours",
    title: "ETA (hrs)",
    sortable: true,
    render: (r: any) => <span>{r.estimated_remaining_hours?.toFixed?.(2)}</span>,
  },
  {
    accessor: "frame_strategy",
    title: "Strategy",
  },
  {
    accessor: "last_update_time",
    title: "Last Update",
    render: (record: any) => {
      const d = new Date(record.last_update_time)
      const date = d.toLocaleDateString("tr-TR")
      const time = d.toLocaleTimeString("tr-TR")

      return (
        <div className="flex flex-col leading-tight">
          <span className="font-medium">{date}</span>
          <span className="text-gray-500 text-xs">{time}</span>
        </div>
      )
    },
  },
  {
    accessor: "start_time",
    title: "Started",
    render: (record: any) => {
      const d = new Date(record.start_time)
      const date = d.toLocaleDateString("tr-TR")
      const time = d.toLocaleTimeString("tr-TR")

      return (
        <div className="flex flex-col leading-tight">
          <span className="font-medium">{date}</span>
          <span className="text-gray-500 text-xs">{time}</span>
        </div>
      )
    },
  },
]
